/**
 * Round 12 #727: the eyebrow every page head carries by default (mock v1.4 "Page head") — on an app's
 * screen "<App> · <the menu holding the page>", on a platform page the platform's display name. The
 * shell computes it from GET /api/apps and /api/meta; a page that names its own eyebrow keeps it.
 */
import { createContext, useContext } from 'react';

export const PageEyebrowContext = createContext<string | null>(null);
export const usePageEyebrow = () => useContext(PageEyebrowContext);
